var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#EF83FF",
    fillOpacity: 0.16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.153 49.4908C39.8344 49.4908 39.5231 49.5852 39.2582 49.7622C38.9933 49.9392 38.7869 50.1907 38.665 50.485C38.5431 50.7793 38.5112 51.1031 38.5734 51.4155C38.6355 51.7279 38.7889 52.0149 39.0141 52.2402C39.2394 52.4654 39.5264 52.6188 39.8388 52.6809C40.1512 52.7431 40.475 52.7112 40.7693 52.5893C41.0636 52.4674 41.3151 52.261 41.4921 51.9961C41.6691 51.7313 41.7635 51.4199 41.7635 51.1013C41.7635 50.6742 41.5938 50.2645 41.2918 49.9625C40.9898 49.6605 40.5801 49.4908 40.153 49.4908Z",
    fill: "#B246C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.153 31.3721C40.8201 31.3721 41.3609 31.9129 41.3609 32.58V44.6591C41.3609 45.3263 40.8201 45.8671 40.153 45.8671C39.4859 45.8671 38.9451 45.3263 38.9451 44.6591V32.58C38.9451 31.9129 39.4859 31.3721 40.153 31.3721Z",
    fill: "#B246C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6144 49.8185L35.1231 25.0923C37.2089 20.9692 43.097 20.9692 45.1829 25.0923L57.6916 49.8185C59.5884 53.568 56.8636 58 52.6617 58H27.6443C23.4423 58 20.7176 53.568 22.6144 49.8185ZM37.2787 26.1829C38.4706 23.8268 41.8353 23.8268 43.0272 26.1829L55.5359 50.909C56.6198 53.0516 55.0628 55.5842 52.6617 55.5842H27.6443C25.2432 55.5842 23.6862 53.0516 24.77 50.909L37.2787 26.1829Z",
    fill: "#B246C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert-icon.cb01c01f867112edf3033739c86cc64c.svg";
export { ForwardRef as ReactComponent };